import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id CD5DD59A-965F-455E-912B-9535BFD134E0
 * name cast-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cast-variant.svg
 * tags
 * - Home Automation 
 */
export const CastVariantIcon = createSvgIcon(<><path d="M6,22H18L12,16M21,3H3A2,2 0 0,0 1,5V17A2,2 0 0,0 3,19H7V17H3V5H21V17H17V19H21A2,2 0 0,0 23,17V5A2,2 0 0,0 21,3Z" /></>, 'CastVariantIcon');
export default CastVariantIcon